const mapCookiePage = (data) => {
  const { text, title } = data;
  return {
    text,
    title
  };
};

export default mapCookiePage;
